import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { useDispatch } from "react-redux"
import { Spin, Button, Result } from "antd"
import { LinkOutlined } from "@ant-design/icons"
import { resolveShortLink } from "store/short-link"
import styles from "./index.module.css"

const REASONS = {
  expired: {
    title: "Link Expired",
    subTitle: "This link has expired and is no longer valid. Please contact the guide for an updated link."
  },
  not_found: {
    title: "Link Not Found",
    subTitle: "This link doesn't exist or may have already been used. Please contact the guide if you need assistance."
  }
}

const ShortLinkRedirect = () => {
  const { token } = useParams()
  const dispatch = useDispatch()
  const [error, setError] = useState(null)

  useEffect(() => {
    dispatch(resolveShortLink(token))
      .then((res) => {
        if (res?.target_url) {
          window.location.assign(res.target_url)
        } else {
          setError("not_found")
        }
      })
      .catch((err) => {
        setError(err?.status === 410 ? "expired" : "not_found")
      })
  }, [token])

  if (error) {
    const content = REASONS[error]
    return (
      <div className={styles.container}>
        <Result
          icon={<LinkOutlined className={styles.icon} />}
          status="404"
          title={<span className={styles.title}>{content.title}</span>}
          subTitle={<div className={styles.subtitle}>{content.subTitle}</div>}
          extra={
            <div className={styles.buttonContainer}>
              <Button type="primary" size="large" onClick={() => window.location.assign("/")}>
                Go to Home
              </Button>
            </div>
          }
        />
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <Spin size="large" />
    </div>
  )
}

export default ShortLinkRedirect
